module.exports = __webpack_public_path__ + "media/images/flags/io-bd4781d818a0fce73e14ff528f81eaca.svg";